export const LOAD = 'CARDS:LOAD'
export const ADD = 'CARDS:ADD'
export const REMOVE = 'CARDS:REMOVE'
export const REFRESH = 'CARDS:REFRESH'
export const CLEAR = 'CARDS:CLEAR'
